// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button[data-v-501577f6]{margin:0 2px}@media print{[data-v-501577f6] .my-component{color:red!important;font-size:16pt!important;margin:0!important;padding:0!important;background-color:green!important}}", ""]);
// Exports
module.exports = exports;
